import { loadStripe, Stripe } from '@stripe/stripe-js';

/**
 * Module-scope Stripe instance — `loadStripe` MUST be called once per page
 * load (per Stripe.js guidance) so subsequent `<Elements>` mounts reuse the
 * same Stripe handle. Re-creating it inside a component (even via `useMemo`)
 * leaks Stripe loaders if React remounts the wrapper.
 *
 * GRO-811 Phase 9 — lifted out of `Settings.component.tsx` so `<Elements>`
 * can wrap the entire Providers tree and the AddPaymentMethod modal becomes
 * reachable from any route (e.g. WhatsappApi credits flow).
 */
export const stripePromise: Promise<Stripe | null> = loadStripe(
  import.meta.env.VITE_STRIPE_KEY_GCS,
);
